import { useContext, useState } from "react";

import { Autocomplete, LoadScript } from "@react-google-maps/api";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";
import { toast } from "react-toastify";
import AccessDenied from "../components/AccessDenied";

const libraries = ["places"];

function AddPitch() {
  const [image1, setImage1] = useState(false);
  const [image2, setImage2] = useState(false);
  const [image3, setImage3] = useState(false);
  const [image4, setImage4] = useState(false);
  const [image5, setImage5] = useState(false);
  const [image6, setImage6] = useState(false);
  const [image7, setImage7] = useState(false);
  const [image8, setImage8] = useState(false);
  const [newRule, setNewRule] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    location: {
      fullLocation: "",
      street: "",
      city: "",
      district: "",
      state: "",
      postalCode: "",
      country: "",
      coordinates: { lat: 0, lng: 0 },
    },
    price: "",
    deposit: "",
    surfaceType: "Doğal",
    amenities: [],
    size: { length: "12", width: "12", unit: "meters" },
    capacity: "12",
    availability: [{ date: "", startTime: "", endTime: "", isBooked: false }],
    images: [],
    rules: [],
    cancellationPolicy: "",
    status: "active",
  });
  const {
    backendURL,
    user,
    token,
    setUser,
    pending,
    navigate,
    setPending,
    setShowAlert,
    setAlertMessage,
  } = useContext(PitchContext);

  const onPlaceChanged = (autocomplete) => {
    const place = autocomplete.getPlace();
    if (place.geometry) {
      const location = {
        fullLocation: place.formatted_address,
        street:
          place.address_components.find(
            (c) =>
              c.types.includes("street_number") || c.types.includes("route")
          )?.long_name || "",
        city:
          place.address_components.find((c) => c.types.includes("locality"))
            ?.long_name || "",
        district:
          place.address_components.find((c) => c.types.includes("sublocality"))
            ?.long_name || "",
        state:
          place.address_components.find((c) =>
            c.types.includes("administrative_area_level_1")
          )?.short_name || "",
        postalCode:
          place.address_components.find((c) => c.types.includes("postal_code"))
            ?.long_name || "",
        country:
          place.address_components.find((c) => c.types.includes("country"))
            ?.long_name || "",
        coordinates: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
      setFormData((prev) => ({ ...prev, location }));
    }
  };

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    const capitalizeFirstLetter = (str) => {
      return str.charAt(0).toLocaleUpperCase("tr-TR") + str.slice(1);
    };

    if (name.includes("size.")) {
      const sizeField = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        size: { ...prev.size, [sizeField]: value },
      }));
    } else if (name.includes("availability.")) {
      const [_, index, field] = name.split(".");
      const updatedAvailability = [...formData.availability];
      updatedAvailability[index] = {
        ...updatedAvailability[index],
        [field]: value,
      };
      setFormData((prev) => ({ ...prev, availability: updatedAvailability }));
    } else if (name.includes("location.")) {
      const locationField = name.split(".")[1];

      const updatedValue =
        locationField === "city" || locationField === "district"
          ? capitalizeFirstLetter(value)
          : value;

      setFormData((prev) => ({
        ...prev,
        location: { ...prev.location, [locationField]: updatedValue },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle amenities toggle
  const toggleAmenity = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      amenities: prev.amenities.includes(value)
        ? prev.amenities.filter((item) => item !== value)
        : [...prev.amenities, value],
    }));
  };

  // Handle image uploads with a max limit of 8
  const handleImageChange = (e, setter) => {
    const file = e.target.files[0];
    if (file) {
      setter(file);
    }
  };

  const addRule = () => {
    if (newRule.trim()) {
      setFormData((prev) => ({
        ...prev,
        rules: [...prev.rules, newRule.trim()],
      }));
      setNewRule("");
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setPending(true);
    const pitchData = new FormData();
    pitchData.append("userID", user._id);
    pitchData.append("name", formData.name);
    pitchData.append("description", formData.description);
    pitchData.append("location", JSON.stringify(formData.location));
    pitchData.append("price", formData.price);
    pitchData.append("deposit", formData.deposit);
    pitchData.append("surfaceType", formData.surfaceType);
    pitchData.append("amenities", JSON.stringify(formData.amenities));
    pitchData.append("size", JSON.stringify(formData.size));
    pitchData.append("capacity", formData.capacity);
    pitchData.append("availability", JSON.stringify(formData.availability));
    pitchData.append("rules", JSON.stringify(formData.rules));
    pitchData.append("cancellationPolicy", formData.cancellationPolicy);
    pitchData.append("status", formData.status);
    image1 && pitchData.append("image1", image1);
    image2 && pitchData.append("image2", image2);
    image3 && pitchData.append("image3", image3);
    image4 && pitchData.append("image4", image4);
    image5 && pitchData.append("image5", image5);
    image6 && pitchData.append("image6", image6);
    image7 && pitchData.append("image7", image7);
    image8 && pitchData.append("image8", image8);

    console.log(image1);

    try {
      const response = await axios.post(
        backendURL + "pitch/create",
        pitchData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        const userRes = await axios.post(
          backendURL + "user/get",
          { userID: user._id },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (userRes.data.success) {
          setShowAlert(true);
          setAlertMessage(
            "Saha eklendi. Detayları sahalarım bölümünden görebilirsiniz."
          );
          localStorage.setItem("user", JSON.stringify(userRes.data.user));
          setUser(userRes.data.user);
          navigate("/profil");
          setPending(false);
        } else {
          toast.error(userRes.data.message, { autoClose: 2000 });
          setPending(false);
        }
      } else {
        toast.error(response.data.message, { autoClose: 2000 });
        setPending(false);
      }
    } catch (err) {
      console.log(err);
      setPending(false);
      toast.error(err.response?.data?.message || "An error occurred", {
        autoClose: 2000,
      });
    }
  };

  if (user.role !== "admin" || !token) {
    return <AccessDenied />;
  }
  return (
    <div className="min-h-screen bg-gray-50">
      {token && user.role === "admin" ? (
        <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-12 animate-fade-in">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4 bg-gradient-to-r from-[#4d9041] to-[#62a556] bg-clip-text text-transparent">
              Yeni bir saha ekleyin
            </h1>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Aşağıdaki bilgileri doldurarak sahanızı güzel bir şekilde
              listeleyebilirsiniz
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 max-w-4xl mx-auto transform transition-all duration-300 hover:shadow-2xl">
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Name */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Saha İsmi *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Açıklama
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  rows="4"
                />
              </div>

              {/* Location */}
              <div className="space-y-4">
                <label className="block text-gray-800 font-semibold mb-2">
                  konum
                </label>
                <LoadScript
                  googleMapsApiKey="AIzaSyCq31_wo46xhO_69AYISoLFGZBPcVuuxa8"
                  libraries={libraries}
                >
                  <Autocomplete
                    onLoad={(autocomplete) =>
                      autocomplete.addListener("place_changed", () =>
                        onPlaceChanged(autocomplete)
                      )
                    }
                    onPlaceChanged={() => {}}
                  >
                    <input
                      type="text"
                      placeholder="Saha konumu için arayın"
                      value={formData.location.fullLocation}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          location: {
                            ...prev.location,
                            fullLocation: e.target.value,
                          },
                        }))
                      }
                      className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                      required
                    />
                  </Autocomplete>
                </LoadScript>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="location.city"
                    value={formData.location.city}
                    onChange={handleChange}
                    placeholder="İl"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                    required
                  />
                  <input
                    type="text"
                    name="location.district"
                    value={formData.location.district}
                    onChange={handleChange}
                    placeholder="İlçe"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                    required
                  />
                </div>
                {formData.location.coordinates.lat !== 0 && (
                  <p className="text-gray-600 text-sm">
                    Coordinates: {formData.location.coordinates.lat},{" "}
                    {formData.location.coordinates.lng}
                  </p>
                )}
              </div>

              {/* Price */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Ücret (₺/saat) *
                </label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  required
                  min="0"
                />
              </div>
              {/* deposit */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Kapora (₺/saat) *
                </label>
                <input
                  type="number"
                  name="deposit"
                  value={formData.deposit}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  required
                  min="0"
                />
              </div>

              {/* Surface Type */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Yüzey Tipi
                </label>
                <select
                  name="surfaceType"
                  value={formData.surfaceType}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                >
                  <option value="Doğal">Doğal</option>
                  <option value="Yapay">Yapay</option>
                </select>
              </div>

              {/* Amenities */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Olanaklar
                </label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 bg-gray-50 p-4 rounded-lg">
                  {[
                    "Soyunma Odaları",
                    "Duşlar",
                    "Tuvaletler",
                    "Otopark",
                    "Oturma Alanı",
                    "Kafeterya",
                    "WiFi",
                    "İlk Yardım",
                    "Kilitli Dolaplar",
                    "Hakem Hizmetleri",
                    "Skor Tahtası",
                    "Çocuk Oyun Alanı",
                    "Takım Kulübeleri",
                    "Etkinlik Odası",
                    "Klima",
                  ].map((amenity) => (
                    <label key={amenity} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        value={amenity}
                        checked={formData.amenities.includes(amenity)}
                        onChange={toggleAmenity}
                        className="w-5 h-5 text-[#4d9041] border-gray-300 rounded focus:ring-[#62a556] transition-all duration-200"
                      />
                      <span className="text-gray-700 text-sm">{amenity}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Size */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Boyutlar (metre)
                </label>
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="number"
                    name="size.length"
                    value={formData.size.length}
                    onChange={handleChange}
                    placeholder="Uzunluk"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                    min="0"
                  />
                  <input
                    type="number"
                    name="size.width"
                    value={formData.size.width}
                    onChange={handleChange}
                    placeholder="Genişlik"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                    min="0"
                  />
                </div>
              </div>

              {/* Capacity */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Kapasite
                </label>
                <input
                  type="number"
                  name="capacity"
                  value={formData.capacity}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  min="0"
                />
              </div>

              {/* Images */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Fotoğraf yükle
                </label>
                <div className="grid grid-cols-4 gap-4">
                  {[
                    setImage1,
                    setImage2,
                    setImage3,
                    setImage4,
                    setImage5,
                    setImage6,
                    setImage7,
                    setImage8,
                  ].map((setter, index) => (
                    <label
                      key={index}
                      htmlFor={`image${index + 1}`}
                      className="cursor-pointer group"
                    >
                      <div className="w-20 h-20 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center border-2 border-dashed border-gray-300 group-hover:border-[#4d9041] transition-all duration-200">
                        <img
                          className="w-full h-full object-cover"
                          src={
                            eval(`image${index + 1}`)
                              ? URL.createObjectURL(eval(`image${index + 1}`))
                              : "./../../public/upload_area.png"
                          }
                          alt=""
                        />
                      </div>
                      <input
                        onChange={(e) => handleImageChange(e, setter)}
                        type="file"
                        id={`image${index + 1}`}
                        accept="image/*"
                        hidden
                      />
                    </label>
                  ))}
                </div>
              </div>

              {/* Rules */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  Kurallar
                </label>
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={newRule}
                    onChange={(e) => setNewRule(e.target.value)}
                    placeholder="Kural yaz"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                  />
                  <button
                    type="button"
                    onClick={addRule}
                    className="bg-[#4d9041] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-200 shadow-md cursor-pointer"
                  >
                    Ekle
                  </button>
                </div>
                {formData.rules.length > 0 && (
                  <ul className="mt-3 space-y-2 text-gray-700">
                    {formData.rules.map((rule, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <span className="text-[#4d9041]">•</span> {rule}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Cancellation Policy */}
              <div>
                <label className="block text-gray-800 font-semibold mb-2">
                  İptal Şartları
                </label>
                <input
                  type="text"
                  name="cancellationPolicy"
                  value={formData.cancellationPolicy}
                  onChange={handleChange}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#4d9041]/40 focus:border-[#62a556] transition-all duration-200"
                />
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  type="submit"
                  disabled={pending}
                  className={`w-full bg-[#4d9041] text-white py-3 rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-200 shadow-md hover:shadow-lg cursor-pointer ${
                    pending ? "opacity-70 cursor-not-allowed" : ""
                  }`}
                >
                  {pending ? "Ekleniyor..." : "Saha Ekle"}
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/profil")}
                  className="w-full bg-gray-200 text-gray-800 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-all duration-200 shadow-md cursor-pointer"
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </section>
      ) : (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center space-y-4 animate-fade-in">
            <h1 className="text-3xl font-bold text-gray-800">Not Authorized</h1>
            <p className="text-lg text-gray-600">
              Bu işlemi yapmak için yetkili değilsinizç
            </p>
            <button
              onClick={() => navigate(-1)}
              className="bg-[#4d9041] text-white py-2 px-6 rounded-lg font-semibold hover:bg-[#62a556] transition-all duration-200 shadow-md"
            >
              Geri dön
            </button>
          </div>
        </div>
      )}

      {/* Custom Animation */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}

export default AddPitch;
